<template>
  <div class="page-home">
    <div class="logo"></div>

    <div class="banner-center-box" v-if="user.calories < 2000">
      <p>{{user.calories | too}}大卡</p>
      <span>还差{{2000-user.calories | too}}大卡即可点亮冲刺奖章！</span>
    </div>
    <div class="banner-center-box" v-if="user.calories >= 2000 && user.calories < 4000">
      <p>{{user.calories | too}}大卡</p>
      <span>还差{{4000-user.calories | too}}大卡即可点亮冲征服奖章！</span>
    </div>
    <div class="banner-center-box" v-if="user.calories >= 4000 && user.calories < 6000">
      <p>{{user.calories | too}}大卡</p>
      <span>还差{{6000-user.calories | too}}大卡即可点亮冲巅峰奖章！</span>
    </div>
    <div class="banner-center" v-if="user.calories >= 6000"></div>

    <div class="pro_acc_box">
      <div class="left">
        <span>挑战目标</span>
        <p>6000</p>
        <span class="">kcal</span>
      </div>
       <div class="main_pro_box" :class="{
        'main_pro_img0': user.calories == 0,
        'main_pro_img1': user.calories >= 250 || user.calories > 0,
        'main_pro_img2': user.calories >= 500,
        'main_pro_img3': user.calories >= 750,
        'main_pro_img4': user.calories >= 1000,
        'main_pro_img5': user.calories >= 1250,
        'main_pro_img6': user.calories >= 1500,
        'main_pro_img7': user.calories >= 1750,
        'main_pro_img8': user.calories >= 2000,
        'main_pro_img9': user.calories >= 2250,
        'main_pro_img10': user.calories >= 2500,
        'main_pro_img11': user.calories >= 2750,
        'main_pro_img12': user.calories >= 3000,
        'main_pro_img13': user.calories >= 3250,
        'main_pro_img14': user.calories >= 3500,
        'main_pro_img15': user.calories >= 3750,
        'main_pro_img16': user.calories >= 4000,
        'main_pro_img17': user.calories >= 4250,
        'main_pro_img18': user.calories >= 4500,
        'main_pro_img19': user.calories >= 4750,
        'main_pro_img20': user.calories >= 5000,
        'main_pro_img21': user.calories >= 5250,
        'main_pro_img22': user.calories >= 5500,
        'main_pro_img23': user.calories >= 5750,
        'main_pro_img24': user.calories >= 6000
      }"></div>
      <div class="right">
        <span>已充能</span>
        <p>{{user.calories | too}}</p>
        <span>kcal</span>
      </div>
    </div>

    <div class="btn-groups">
      <div class="code1" :class="{'code1_act': user.calories >= 2000}"></div>
      <div class="code2" :class="{'code2_act': user.calories >= 4000}"></div>
      <div class="code3" :class="{'code3_act': user.calories >= 6000}"></div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import {} from '../service/bridge.js'

export default {
  name: 'home',
  data () {
    return {
      totalNum: 0
    }
  },
  components: {

  },
  computed: {
    ...mapState([
      'user'
    ])
  },
  methods: {
  },
  mounted () {
    //
    const vm = this;
  }
}
</script>

<style scoped lang="scss">
#app {
  background: #000;
  position: absolute;
  width: 100%;
  min-height: 100%;
}
.page-home{
  position: absolute;
  color: #000;
  font-size: 60px;
  width: 100%;
  height: 100%;
  min-height: 1218px;
  background:#000 url('../assets/images/bg_page_load.jpg') no-repeat top center;
  .banner-center{
    margin: 0 auto;
    margin-top: 10%;
    width:563px;
    height: 215px;
    background: url('../assets/images/code_slgon3.png') no-repeat;;
    background-size: 100%;
  }
  .banner-center-box {
    margin: 0 auto;
    margin-top: 10%;
    width:660px;
    height: 218px;
    background: url('../assets/images/code_slgon4.png') no-repeat;;
    background-size: 100%;
    color: #ffe100;
    p {
      margin: 0;
      text-align: right;
      font-size: 98px;
      padding-top: 80px;
    }
    span {
      text-align: right;
      letter-spacing: 10px;
      display: block;
      font-size: 22px;
      color: #71f300;
    }
  }
  .pro_acc_box {
    position: absolute;
    left: 50%;
    top:50%;
    transform: translate(-50%,-25%);
    -webkit-transform: translate(-50%, -25%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 738px;
    .left,.right {
      color: #ffe100;
      margin-right: -50px;
      span {
        display: block;
        font-weight: bold;
        font-size: 30px;
      }
      p {
        margin: 0;
        font-weight: bold;
        font-size: 63px;
      }
    }
    .right {
      min-width: 120px;
      margin-right: 0;
      margin-left: -45px;
      color: #00c915;
      max-width: 218px;
      p {
        max-width: 218px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
    .main_pro_box {
      width: 398px;
      height: 738px;
    }
    .main_pro_img0 {
       background: url('../assets/images/act_pro_img0s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img1 {
       background: url('../assets/images/act_pro_img1s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img2 {
       background: url('../assets/images/act_pro_img2s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img3 {
       background: url('../assets/images/act_pro_img3s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img4 {
       background: url('../assets/images/act_pro_img4s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img5 {
       background: url('../assets/images/act_pro_img5s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img6 {
       background: url('../assets/images/act_pro_img6s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img7 {
       background: url('../assets/images/act_pro_img7s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img8 {
       background: url('../assets/images/act_pro_img8s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img9 {
       background: url('../assets/images/act_pro_im9s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img10 {
       background: url('../assets/images/act_pro_img10s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img11 {
       background: url('../assets/images/act_pro_img11s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img12 {
       background: url('../assets/images/act_pro_img12s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img13 {
       background: url('../assets/images/act_pro_img13s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img14 {
       background: url('../assets/images/act_pro_img14s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img15 {
       background: url('../assets/images/act_pro_img15s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img16 {
       background: url('../assets/images/act_pro_img16s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img17 {
       background: url('../assets/images/act_pro_img17s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img18 {
       background: url('../assets/images/act_pro_img18s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img19 {
       background: url('../assets/images/act_pro_img19s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img20 {
       background: url('../assets/images/act_pro_img20s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img21 {
       background: url('../assets/images/act_pro_img21s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img22 {
       background: url('../assets/images/act_pro_img22s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img23 {
       background: url('../assets/images/act_pro_img23s_03.png') no-repeat;;
       background-size: 100%;
    }
    .main_pro_img24 {
       background: url('../assets/images/act_pro_img24s_03.png') no-repeat;;
       background-size: 100%;
    }
  }
}
 .btn-groups{
    position: absolute;
    bottom: 1%;
    width: 90%;
    left: 50%;
    margin-left: -45%;
    height: 210px;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: space-around;
    div {
      width: 222px;
      height: 168px;
      margin: 0 auto;
    }
    .code1 {
       background: url('../assets/images/code1.png') no-repeat;;
       background-size: 100%;
    }
    .code2 {
       background: url('../assets/images/code2.png') no-repeat;;
       background-size: 100%;
    }
    .code3 {
      background: url('../assets/images/code3.png') no-repeat;;
      background-size: 100%;
    }
    .code1_act {
      background: url('../assets/images/code1_act.png') no-repeat;;
       background-size: 100%;
    }
    .code2_act {
      background: url('../assets/images/code2_act.png') no-repeat;;
       background-size: 100%;
    }
    .code3_act {
      background: url('../assets/images/code3_act.png') no-repeat;;
       background-size: 100%;
    }
  }

@media only screen
    and (device-width : 375px)
    and (device-height : 812px)
    and (-webkit-device-pixel-ratio : 3) {
      .pro_acc_box {
        bottom: 20%;
      }
}

</style>
